const LOCAL_API_URL = process.env.REACT_APP_API_URL_LOCAL || 'http://localhost:5000';
const PRODUCTION_API_URL = process.env.REACT_APP_API_URL_PRODUCTION || 'https://tkfashion.onrender.com';
const EXPLICIT_API_URL = process.env.REACT_APP_API_URL || '';

const isLocalUrl = (value = '') => /https?:\/\/(localhost|127\.0\.0\.1)(:\d+)?/i.test(value);
const isLocalFrontend = () => {
  if (typeof window === 'undefined') return false;
  return /^(localhost|127\.0\.0\.1)$/i.test(window.location.hostname);
};

export const API_BASE_URL = (() => {
  if (isLocalFrontend()) {
    return LOCAL_API_URL || EXPLICIT_API_URL || PRODUCTION_API_URL;
  }

  if (EXPLICIT_API_URL && !isLocalUrl(EXPLICIT_API_URL)) {
    return EXPLICIT_API_URL;
  }

  return PRODUCTION_API_URL;
})();

export const resolveApiMediaUrl = (url) => {
  if (!url) return '';
  if (/^https?:\/\//i.test(url)) return url;
  return `${API_BASE_URL}${url}`;
};
